// CampaignTable.jsx
import { useNavigate } from "react-router-dom";
import { Pencil, Trash2 } from "lucide-react";

const statusConfig = {
  active: {
    label: "فعال",
    className: "bg-[#00AFA9]/10 text-[#00938E]",
  },
  scheduled: {
    label: "زمان‌بندی‌شده",
    className: "bg-[#FFC107]/15 text-[#9A6C00]",
  },
  expired: {
    label: "منقضی‌شده",
    className: "bg-red-100 text-red-600",
  },
  inactive: {
    label: "غیرفعال",
    className: "bg-red-100 text-red-600",
  },
};

const formatDate = (value) => {
  if (!value) return "-";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";

  return new Intl.DateTimeFormat("fa-IR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
};

const CampaignTable = ({ campaigns = [], onDelete, deletingSlug }) => {
  const navigate = useNavigate();

  return (
    <div className="rounded-2xl border border-gray-200 bg-white shadow-sm">

      <div dir="rtl" className="overflow-x-auto">
        <table className="min-w-[920px] w-full border-collapse">
          <thead className="bg-gray-50">
            <tr className="text-right text-xs font-medium text-gray-600">
              <th className="px-3 py-3 text-center">ردیف</th>
              <th className="px-3 py-3">عنوان رویداد</th>
              <th className="px-3 py-3 text-center">بازه فعالیت</th>
              <th className="px-3 py-3 text-center">تعداد کالا</th>
              <th className="px-3 py-3 text-center">وضعیت</th>
              <th className="px-3 py-3 text-center">عملیات</th>
            </tr>
          </thead>

          <tbody className="text-sm text-gray-700">
            {campaigns.length === 0 && (
              <tr className="border-t border-gray-100">
                <td colSpan={6} className="px-4 py-10 text-center">
                  <div className="mx-auto max-w-sm">
                    <p className="text-sm font-medium text-gray-700">
                      رویدادی ثبت نشده است.
                    </p>
                    <p className="mt-1 text-sm text-gray-500">
                      برای شروع، یک رویداد جدید اضافه کنید.
                    </p>
                  </div>
                </td>
              </tr>
            )}

            {campaigns.map((campaign, index) => {
              const status = statusConfig[campaign.status];

              return (
                <tr
                  key={campaign.slug || campaign.id}
                  className="border-t border-gray-100 transition-colors hover:bg-gray-50"
                >
                  <td className="px-3 py-3 text-center text-gray-500">
                    {index + 1}
                  </td>

                  <td className="px-3 py-3">
                    <div className="flex flex-col gap-1">
                      <span className="font-medium text-gray-900">
                        {campaign.title}
                      </span>
                      {campaign.slug && (
                        <span className="text-[11px] text-gray-500">
                          {campaign.slug}
                        </span>
                      )}
                    </div>
                  </td>

                  <td className="px-3 py-3 text-center text-gray-700">
                    {formatDate(campaign.starts_at)} - {formatDate(campaign.ends_at)}
                  </td>

                  <td className="px-3 py-3 text-center">
                    <span className="inline-flex rounded-full bg-gray-100 px-2 py-1 text-xs font-medium text-gray-700">
                      {campaign.products_count ?? 0}
                    </span>
                  </td>

                  {/* بج وضعیت — طبق سیستم طراحی: rounded-full px-1.5 py-0.5 text-[10px] font-medium */}
                  <td className="px-3 py-3 text-center">
                    <span
                      className={`inline-flex rounded-full px-1.5 py-0.5 text-[10px] font-medium ${
                        status?.className || "bg-gray-100 text-gray-700"
                      }`}
                    >
                      {status?.label || campaign.status || "-"}
                    </span>
                  </td>

                  <td className="px-3 py-3">
                    <div className="flex items-center justify-center gap-3">
                      {/* دکمه ویرایش — secondary */}
                      <button
                        type="button"
                        onClick={() =>
                          navigate(`/admin-panel/campaigns/${campaign.slug}/edit`)
                        }
                        className="inline-flex h-10 items-center justify-center gap-2 rounded-lg bg-[#F5F5F5] px-3 text-sm font-medium text-[#1E3A5F] transition-colors duration-200 hover:bg-[#DBDBDB] hover:text-[#12233A] focus:border-[#1E3A5F] focus:outline-none"
                      >
                        <Pencil className="h-4 w-4" />
                        ویرایش
                      </button>

                      {/* دکمه حذف — danger */}
                      <button
                        type="button"
                        disabled={deletingSlug === campaign.slug}
                        onClick={() => onDelete(campaign)}
                        className="inline-flex h-10 items-center justify-center gap-2 rounded-lg bg-[#E74C3C] px-3 text-sm font-medium text-white transition-colors duration-200 hover:bg-[#C0392B] hover:text-[#F8F8F8] disabled:cursor-not-allowed disabled:opacity-50 focus:outline-none"
                      >
                        <Trash2 className="h-4 w-4" />
                        {deletingSlug === campaign.slug ? "در حال حذف..." : "حذف"}
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CampaignTable;